export const user = {
    types: {
        ADMIN: "Administrador",
        MANAGER: "Gestor",
    },
    labels: {
        uninformed: "Não Informado",
        password: "Senha",
        confirm_password: "Confirmar Senha",
    },
    placeholders: {
        password: "Insira a Senha",
        confirm_password: "Confirme a Senha",
    },
    modals: {
        titles: {
            user_add: "Adicionar Usuário",
            user_remove: "Remover Usuário",
        },
        messages: {
            user_remove: "Tem certeza que deseja remover o usuário <strong>{name}</strong>?<br/>Essa ação não pode ser desfeita.",
        }
    }
};
